import type { FunctionComponent } from "react";

import type { ArticlesSearchFilterByDateRange } from "~/components/search/contexts";
import { useSearchContext } from "~/components/search/contexts";
import { DropdownMenu } from "~/components/search/search-result-panel/components/dropdown-menu";

import { DateRangeOptions } from "./const";

type Props = {
  className?: string;
};

export const DateRangeMenu: FunctionComponent<Props> = ({ className }) => {
  const { dateRange, setDateRange } = useSearchContext();
  const handleOnDateRangeChanged = (selectedDateRange: ArticlesSearchFilterByDateRange) => {
    setDateRange?.({ ...selectedDateRange });
  };

  return (
    <DropdownMenu
      className={className}
      options={DateRangeOptions}
      placeholder="Date Range"
      selectedOptionValue={dateRange}
      onOptionSelect={handleOnDateRangeChanged}
    />
  );
};
